
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-access/customer",
      function () {
        return require("private-next-pages/request-access/customer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-access/customer"])
      });
    }
  